import { saveStorage } from "../api/upload";

const permission = {
  state: {
    imgServiceURL: "",
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: {
    async saveStorage(payload = {}, rootState) {
      const response = await saveStorage(payload);
      this.setState({ imgServiceURL: response.previewLink });
      return response;
    },
  },
};

export default permission;
